module.exports = __webpack_public_path__ + "static/media/user1.25ad4067.svg";